<section class="container p-0 py-md-2">

  <div class=" grid-shadow1 grid-shadow1-remove px-md-5 mx-auto login-section">
    <section [hidden]="!loginBoolean">
      <div>
        <h3 class="heading4 mb-4">Login</h3>
      </div>

      <section>
        <div class="text-center">
          <ul class="nav nav-pills mb-3 login-tabs-section rounded-pill p-2 d-inline-flex" id="pills-tab"
            role="tablist">
            <li class="nav-item me-2" role="presentation">
              <button class="nav-link active" (click)="ResetFormOnTabClick()" id="pills-home-tab" data-bs-toggle="pill"
                data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                aria-selected="true">Mobile Number</button>
            </li>
            <li class="nav-item me-2" role="presentation">
              <button class="nav-link" (click)="ResetFormOnTabClick()" id="pills-profile-tab" data-bs-toggle="pill"
                data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                aria-selected="false">Email ID</button>
            </li>
          </ul>
        </div>

        <div class="tab-content mt-4" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"
            tabindex="0">
            <form [formGroup]="mobileForm">
              <div class="row mb-2">
                <div class="col-md-4 mb-2">
                  <label class="field-label">Country Code <span class="text-danger">*</span></label>
                  <mat-form-field>
                    <mat-select formControlName="mobileCode">
                      <mat-option *ngFor="let code of countryCodes" [value]="code.masterDataID">
                        <span> {{code.mdTitle}}</span>
                      </mat-option>
                    </mat-select>

                  </mat-form-field>
                  <div
                    *ngIf="isSubmittedMobile && mobileForm.get('mobileCode')?.invalid && mobileForm.get('mobileCode')?.errors?.['required']"
                    class="error-message">
                    Country Code is required.
                  </div>
                </div>
                <div class="col-md-8 mb-2">
                  <label class="field-label">Mobile Number <span class="text-danger">*</span></label>
                  <mat-form-field class="w-100 mat-form-field-sm">
                    <input matInput (keypress)="numberOnly($event)" type="text" formControlName="mobileNumber">
                  </mat-form-field>
                  <div class="text-red small"
                    *ngIf="isSubmittedMobile && mobileForm.get('mobileNumber')?.invalid && mobileForm.get('mobileNumber')?.errors?.['required']">
                    Mobile Number is required.
                  </div>
                  <div class="text-red small"
                    *ngIf="isSubmittedMobile && mobileForm.get('mobileNumber')?.invalid && mobileForm.get('mobileNumber')?.errors?.['minlength']">
                    Mobile number should be at least 9 digits long.
                  </div>
                  <div class="text-red small"
                    *ngIf="isSubmittedMobile && mobileForm.get('mobileNumber')?.invalid && mobileForm.get('mobileNumber')?.errors?.['maxlength']">
                    Mobile number should not exceed 9 digits.
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <button class="secondary-Button w-100 rounded" (click)="MobileFormSubmit()">Proceed</button>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
            tabindex="0">
            <form [formGroup]="emailForm">
              <div class="mb-2">
                <label class="field-label">Email ID <span class="text-danger">*</span></label>
                <mat-form-field class="w-100 mat-form-field-sm">
                  <input matInput type="email" formControlName="emailId">
                </mat-form-field>
                <div *ngIf="isSubmittedEmail && emailForm.get('emailId')?.errors?.['required']" class="text-red small">
                  Email ID is required.
                </div>
                <div class="text-red small"
                  *ngIf="isSubmittedEmail && emailForm.get('emailId')?.invalid && emailForm.get('emailId')?.errors?.['email']">
                  Enter valid email.
                </div>
              </div>
              <div class="mt-4">
                <button class="secondary-Button w-100 rounded" (click)="EmailFormSubmit()">Proceed</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </section>

    <section [hidden]="loginBoolean">
      <div class="text-center mt-5" *ngIf="emaiauthentication">
        <p>{{emaiauthentication}}</p>
      </div>

      <form class="form mt-3" [formGroup]="OTPForm">
        <div>
          <div class="classfifty input-group form-group justify-content-center mt-2">
            <div class="input-group-prepend mb-2 mb-sm-0">
              <span class="input-group-text colordiv"><i class="fa fa-lock lockIcon colordiv"></i></span>
            </div>
            <div class="otp-input-container">
              <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
                <input #otpInput type="tel" minlength="1" maxlength="1" (keypress)="numberOnly($event)"
                  (input)="onInputChange($event,'otp' + index)" [id]="'otp' + index"
                  (keydown)="onBackspaceKeyDown($event, index)" [formControlName]="'otp' + index"
                  (keyup)="onOtpInput(index)">
              </div>
            </div>
          </div>
          <div class=" classfifty input-group form-group justify-content-center my-3">
            <div *ngIf="b['otp'].errors && submittedotp" class="small">
              <div *ngIf="b['otp'].errors['required']" class="text-danger letterspacing">
                {{'OTP_is_required'|translate}} </div>

            </div>
          </div>
          <p class="text-center mb-1 mt-3" *ngIf="showResend==false ">{{'OTP_request' | translate}}</p>

          <div class="load" *ngIf="showResend==false ">
            <div class="progress-time mx-4" [style.--progress-value]="timeRemaining_percent">
              <progress style="visibility:hidden;height:0;width:0;"></progress>
              <span class="progress-value">{{remainingTime}}</span>
            </div>
          </div>

          <div class="text-center m-2" *ngIf="showResend==true">
            <p class="mt-3">{{'OTP_Question' | translate}} <a href="javascript: void(0)"
                (click)="resendOtp()">{{'Resend_OTP' | translate}}</a></p>

          </div>

          <div class="form-group text-center my-2 mt-4 submit">
            <button class="classfifty btn btn-block btnreset capitilize letterSpacing m-1" (click)="goBack()"
              type="reset"><em class="fa fa-fw fa-arrow-left"></em>
              {{'Go_Back'|translate}}
            </button>&nbsp;
            <button type="submit" class="classfifty btn btnc btn-block  m-1" (click)="otpSubmit()"><em
                class="fa fa-fw fa-key"></em>
              {{'Validate_OTP'|translate}}
            </button>

          </div>

        </div>
      </form>
    </section>

  </div>
</section>